import { Component, EventEmitter, Output, ChangeDetectionStrategy } from "@angular/core";
import { Field, HandleBitSet } from "../../../../domain/dynamic-form-model";
import { BaseFieldComponent } from "../utils/base-field.component";
import { BaseFieldHtmlComponent } from "../utils/base-field-html.component";
import { ReactiveFormsModule } from "@angular/forms";
import { NgClass } from "@angular/common";

@Component({
  selector: 'app-scale-field',
  standalone: true,
  templateUrl: 'scale-field.component.html',
  styleUrls: ['scale-field.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BaseFieldHtmlComponent,
    ReactiveFormsModule,
    NgClass
  ]
})

export class ScaleFieldComponent extends BaseFieldComponent {

  @Output() handleBitSets = new EventEmitter<Field>();
  @Output() handleBitSetsOfComposite = new EventEmitter<HandleBitSet>();

  text_left: string | null = null;
  text_right: string | null = null;

  override ngOnInit() {
    super.ngOnInit();
    const properties = this.fieldData.typeInfo.properties;

    if (properties && 'textLeft' in properties) {
      this.text_left = properties.textLeft as string;
    }

    if (properties && 'textRight' in properties) {
      this.text_right = properties.textRight as string;
    }
  }
}
